import uniq from "lodash/fp/uniq";
/**
 * 获取数据中一列的范围
 *
 * @author 张卓诚
 * @export
 * @template S
 * @template N
 * @param {ITable<S, N>} chartData 图表数据
 * @param {number} index 列号
 * @returns
 */
export function getRangeByIndex(chartData, index) {
    if (index < 0 || chartData.range.length < index) {
        throw new Error(`index现在为${index}超出范围[0,${chartData.range.length - 1}]`);
    }
    if (chartData.range && chartData.range[index] && chartData.range[index].length > 0) {
        return chartData.range[index];
    }
    const result = uniq(chartData.data.map(item => item[index]));
    return result;
}
/**
 * 根据给定的字符组合筛选出符合条件的数字
 * 非常抽象，只用于2分类及2分类以上的图表
 *
 * @author 张卓诚
 * @export
 * @template S
 * @template N
 * @param chartData 图表数据
 * @param filters 过滤器，按照0-n中不为undefined的列的值筛选，并按照0-n中为undefined的列对应的range排序
 * @returns
 */
export function getNumbersByStrings(chartData, filters) {
    const data = chartData.data;
    const numberOfString = data[0].filter(item => typeof item === "string").length;
    const numberOfNumber = data[0].filter(item => typeof item === "number").length;
    const indexOfString = filters.lastIndexOf(undefined);
    const ranges = getRangeByIndex(chartData, indexOfString + 1);
    const filterUndefineNumber = filters.filter(item => item === undefined).length;
    if ((filterUndefineNumber !== 1)) {
        throw new Error(`filters 参数中应该有1列为undefined，现在有${filterUndefineNumber}列`);
    }
    /** 返回过滤函数，按照所有的字符做过滤 */
    function filter(item) {
        const filterCopy = filters.concat();
        filterCopy[indexOfString] = item;
        return (dataLine) => {
            for (let index = 0; index < filterCopy.length; index++) {
                if (dataLine[index + 1] !== filterCopy[index]) {
                    return false;
                }
            }
            return true;
        };
    }
    const result = ranges.map(item => {
        const filted = data.filter(filter(item));
        if (filted.length > 0) {
            return filted[0].slice(numberOfString);
        }
        return [].fill(undefined, 0, numberOfNumber);
    });
    return result;
}
//# sourceMappingURL=index.js.map